import React, { Component } from "react";
import { connect } from "react-redux";

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

import { getCategoryProducts } from "../actions/siteActions";

import Product from "./Product";

var hex2rgba = require("hex2rgba");

class Pages extends Component {
  componentDidMount = () => {
    this.getCurrentCategoryPages();
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.site.current.category !== prevProps.site.current.category) {
      this.getCurrentCategoryPages();
    }
    if (this.props.site.products !== prevProps.site.products) {
      this.generateCurrentCategoryProductsPages();
    }
  };

  getCurrentCategoryPages = () => {
    const { site, category } = this.props;

    this.props.getCategoryProducts(category.id);
    //console.log(category);
  };

  generateCurrentCategoryProductsPages = (secondary = 0) => {
    const { site, category } = this.props;

    if (site.products && site.products[category.id]) {
      //console.log(site.products[category.id], category.id);

      return Object.keys(site.products[category.id]).map((index, i) => {
        const product = site.products[category.id][index];

        if (isMobile) {
          return <Product key={i} product={product} />;
        } else {
          /*
 35 toodet
 0 -> 1-5                 min = 0   max = 5
 1 -> 6-10 11-15          min = 6   max = 10  sec min= 11  max=15
 2 -> 16-20 21-25         min =     max = 
 3 -> 26-30 31-35         min =     max = 
 4 -> 36-40 41-45         min =     max = 
 5 -> 46-50 ...
 */

          let pageNr = site.current.page;
          //console.log("pageNr = " + pageNr);
          // const minArrayPos = (pageNr + Math.floor(pageNr / 2)) * 5 + (secondary * 5) + 1;
          // const maxArrayPos = (pageNr + Math.floor(pageNr / 2) + 1) * 5 + (secondary * 5);
          let minArrayPos, maxArrayPos;

          if (pageNr === 0) {
            minArrayPos = 0;
            maxArrayPos = 5;
          } else {
            minArrayPos = secondary ? pageNr * 10 : pageNr * 10 - 5;
            maxArrayPos = secondary ? pageNr * 10 + 5 : pageNr * 10;
          }

          //console.log(minArrayPos, maxArrayPos);
          if (minArrayPos <= i && i < maxArrayPos) {
            //console.log(site.current.page);
            return <Product key={i} product={product} />;
          }
        }
      });
    }
  };

  getCurrentCategoryName = () => {
    const { site } = this.props,
      category = site.current.category;

    if (category && category.acf.pealkiri_2) {
      return category.acf.pealkiri_2;
    } else {
      return category.name;
    }
  };

  generateProductsHeader = () => {
    const { site } = this.props;

    return (
      <div className="header">
        <img
          className="logo"
          src={process.env.PUBLIC_URL + "/img/ep_logo.svg"}
          alt="eestipagar"
        />
        <h2
          style={{
            color: site.current.category.acf.varvus,
          }}
          dangerouslySetInnerHTML={{ __html: this.getCurrentCategoryName() }}
        >
          {}
        </h2>
        <div
          className="line"
          style={{
            backgroundColor: site.current.category.acf.varvus,
          }}
        ></div>
      </div>
    );
  };

  showLastPageImage = () => {
    const { site, category } = this.props;

    const page = site.current.page;
    const productCount = Object.keys(site.products[category.id]).length;
    /*
 35 toodet
 1-5 
 6-10 11-15 
 16-20 21-25 
 26-30 31-35 
 36-40 41-45 
 46-50 ...

 */

    if (
      page !== 0 &&
      productCount > 5 + (page - 1) * 10 &&
      productCount <= 10 + (page - 1) * 10
    ) {
      return true;
    }
    return false;
  };

  generateProductsPage = (secondary = 0) => {
    const { site, category } = this.props;
    /*
this.showLastPageImage() ? (
      <div>qpowdk</div>
    ) : 
*/
    return (
      <div className="page">
        {this.generateProductsHeader()}
        <div className="products">
          {this.generateCurrentCategoryProductsPages(secondary)}
        </div>
      </div>
    );
  };

  generateCategoryTitlePage = (withTitles = true) => {
    const { site } = this.props;
    const category = site.current.category;
    // console.log("generateCategoryTitlePage", category);
    if (category && category.acf && category.acf.avalehe_pilt) {
      return (
        <div className="page">
          <div
            className="titleImage"
            style={{
              backgroundImage:
                "url(" + category.acf.avalehe_pilt.sizes.medium_large + ")",
            }}
          >
            {withTitles && (
              <div
                className="pealkiri"
                style={{
                  top: category.acf.headerposition + "%",
                  backgroundColor: hex2rgba(
                    category.acf.varvus_2
                      ? category.acf.varvus_2
                      : category.acf.varvus,
                    0.85
                  ),
                }}
              >
                <h2
                  dangerouslySetInnerHTML={{
                    __html: this.getCurrentCategoryName(),
                  }}
                ></h2>
              </div>
            )}
            {withTitles && (
              <p
                dangerouslySetInnerHTML={{
                  __html: category.acf.kirjeldus,
                }}
              ></p>
            )}
          </div>
        </div>
      );
    } else {
      return <p>&nbsp;</p>;
    }
  };

  render() {
    const { site, category } = this.props;

    return (
      <React.Fragment>
        {site.products && site.products[category.id] && (
          <React.Fragment>
            {" "}
            <BrowserView>
              {site.current.page === 0 && this.generateCategoryTitlePage()}
              {this.generateProductsPage()}
              {site.current.page !== 0
                ? this.showLastPageImage()
                  ? this.generateCategoryTitlePage(false)
                  : this.generateProductsPage(1)
                : ""}
            </BrowserView>
            <MobileView>{this.generateProductsPage(1)}</MobileView>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
/*

   <div className="page">PAGE</div>
        <div className="page" style={{ backgroundColor: "#FF00FF" }}>
          PAGE 2
        </div>
*/
const mapStateToProps = (state) => ({
  site: state.site,
  category: state.site.current && state.site.current.category,
});

export default connect(mapStateToProps, { getCategoryProducts })(Pages);
